export const lockerCollectionGuard = 'GET /lockers/list';
export const lockerResourceGuard = 'GET /lockers/d+';
export const createLockerResourceGuard = 'POST /lockers';
export const editLockerResourceGuard = 'PUT /lockers/d+';
export const deleteLockerResourceGuard = 'DELETE /lockers/d+';

export const availableLockerCollectionGuard = 'GET /lockers/available';
